module.exports = __webpack_public_path__ + "img/img23.115593b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img23.png
// module id = 368
// module chunks = 0